export function dealerCreditUnitPrice(config) {
  return Math.max(1, Number(config?.dealer_credit_unit_price ?? 7));
}

export const DEALER_MIN_MONTHLY_CREDITS = 5000;

export function dealerMonthlyCreditsFromInput(manualCreditsRaw) {
  const n = Math.floor(Number(manualCreditsRaw));
  if (!Number.isFinite(n) || n < DEALER_MIN_MONTHLY_CREDITS) return null;
  return n;
}

export function dealerMonthlyPriceHuf(config, credits) {
  const unit = dealerCreditUnitPrice(config);
  return Math.max(1, Math.floor(Number(credits)) * unit);
}
